import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { intl } from 'i18n';

export interface AdviceRoomMeetingSummary {
  meetingId: string;
  status: string;
  title: string;
  summary: string;
  createdAt: string;
  updatedAt: string;
  actionItems: Record<string, string[]>;
}

export function adviceRoomMeetingSummaryApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<JsonApiResponseSingle>(path, {
        // @ts-expect-error
        skipRedirect: true,
        message: intl.formatMessage({ id: 'adviceRooms.meetingSummary.summaryPermissionError' }),
      }),
    PATCH: (data: any) =>
      api.patch(path, {
        data: {
          attributes: {
            ...data,
          },
        },
      }),

    print: () => api.get(`${path}/print`),
    share: (action: 'add' | 'remove', client_user_ids: number[]) =>
      api.patch(`${path}/share`, {
        data: {
          attributes: {
            action,
            client_user_ids,
          },
        },
      }),

    consent: (response: boolean) =>
      api.post(`${path}/consent`, {
        data: {
          attributes: {
            consent: response,
          },
        },
      }),

    retry: () => api.post(`${path}/retry`),
    status: () => api.get(`${path}/status`),
  };
}
